import React from 'react';
import {connect} from 'react-redux';
import {findLabels} from '../../../../../actions/contactsGroupItemActions';
import {findSystemGroups} from '../../../../../actions/systemGroupActions';
import SharingDetailsPopup from '../sharing-details-popup';
import Sharing from '../../../sharing'
import SharingDetailsLv2Popup from '../sharing-details-lv2-popup'
import './index.css';

class GmailAddOnSharingDetails extends React.PureComponent {

    componentDidMount() {
        this.loadLabels();
    }

    loadLabels = () => {
        this.props.findSystemGroups();
        this.props.FindLabels(undefined, true);
    };

    render() {
        const {sharingDetailsPopup, checkGmailAddOnData} = this.props
        return (
            <div className='popup-for-gmail-addon popup-responsive'>
                {checkGmailAddOnData.action === 'addToAContact'
                    ?
                    sharingDetailsPopup[1] === 'gmail_contact_details' ||
                    sharingDetailsPopup[1] === 'gmail_new_contact'
                        ?
                        (<>
                            <SharingDetailsLv2Popup/>
                            <SharingDetailsPopup/>
                        </>)
                        :
                        <Sharing/>
                    :
                    <>
                        <SharingDetailsLv2Popup/>
                        <SharingDetailsPopup/>
                    </>
                }
            </div>

        )

    }
}

const mapStateToProps = (state) => {
    return {
        checkGmailAddOnData: state.profileReducer.setGmailAddOnData,
        sharingDetailsPopup: state.sharingDetailsReducer.getSharingDetailsPopup
    };
};

const mapDispatchToProps = (dispatch) => ({
    FindLabels: (pageSize, directLaunch) => {
        dispatch(findLabels(pageSize, directLaunch));
    },
    findSystemGroups: () => {
        dispatch(findSystemGroups())
    }

});

export default connect(mapStateToProps, mapDispatchToProps)(GmailAddOnSharingDetails);
